import { cloneElement } from 'react'
import { Link } from './ConditionalLink.styles'
import type { ConditionalLinkProps } from './ConditionalLink.types'

export const ConditionalLink = ({
  condition = true,
  href,
  children,
  CustomLink = Link,
  ...rest
}: ConditionalLinkProps): JSX.Element => {
  if (href && href !== '' && href !== '#' && condition) {
    return (
      <CustomLink href={href} {...rest}>
        {children}
      </CustomLink>
    )
  }

  return cloneElement(<div className="conditional-link-void">{children}</div>, {
    ...rest,
  })
}
